module.exports = __webpack_public_path__ + "static/img/triangle-down.9713307f.svg";